/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as App_authRouteRouteImport } from './routes/_app/__auth/route'
import { Route as App_notAuthRouteRouteImport } from './routes/_app/__not-auth/route'
import { Route as AppContactsRouteRouteImport } from './routes/_app/contacts/route'
import { Route as AppPrivacyRouteRouteImport } from './routes/_app/privacy/route'
import { Route as AppTermsRouteRouteImport } from './routes/_app/terms/route'
import { Route as App_authIndexRouteImport } from './routes/_app/__auth/index'
import { Route as App_notAuthLoginRouteRouteImport } from './routes/_app/__not-auth/login/route'
import { Route as App_notAuthRegisterRouteRouteImport } from './routes/_app/__not-auth/register/route'
import { Route as App_authAdminIndexRouteImport } from './routes/_app/__auth/admin/index'
import { Route as App_authAgentIndexRouteImport } from './routes/_app/__auth/agent/index'
import { Route as App_authDashboardIndexRouteImport } from './routes/_app/__auth/dashboard/index'
import { Route as App_authMerchantIndexRouteImport } from './routes/_app/__auth/merchant/index'
import { Route as AppProposalUuidIndexRouteImport } from './routes/_app/proposal/$uuid/index'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const App_authRouteRoute = App_authRouteRouteImport.update({
  id: '/__auth',
  getParentRoute: () => AppRoute,
} as any)
const App_notAuthRouteRoute = App_notAuthRouteRouteImport.update({
  id: '/__not-auth',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRouteRoute = AppContactsRouteRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppPrivacyRouteRoute = AppPrivacyRouteRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppRoute,
} as any)
const AppTermsRouteRoute = AppTermsRouteRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => AppRoute,
} as any)
const App_authIndexRoute = App_authIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => App_authRouteRoute,
} as any)
const App_notAuthLoginRouteRoute = App_notAuthLoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => App_notAuthRouteRoute,
} as any)
const App_notAuthRegisterRouteRoute =
  App_notAuthRegisterRouteRouteImport.update({
    id: '/register',
    path: '/register',
    getParentRoute: () => App_notAuthRouteRoute,
  } as any)
const App_authAdminIndexRoute = App_authAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => App_authRouteRoute,
} as any)
const App_authAgentIndexRoute = App_authAgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => App_authRouteRoute,
} as any)
const App_authDashboardIndexRoute = App_authDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => App_authRouteRoute,
} as any)
const App_authMerchantIndexRoute = App_authMerchantIndexRouteImport.update({
  id: '/merchant/',
  path: '/merchant/',
  getParentRoute: () => App_authRouteRoute,
} as any)
const AppProposalUuidIndexRoute = AppProposalUuidIndexRouteImport.update({
  id: '/proposal/$uuid/',
  path: '/proposal/$uuid/',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof App_authIndexRoute
  '/contacts': typeof AppContactsRouteRoute
  '/privacy': typeof AppPrivacyRouteRoute
  '/terms': typeof AppTermsRouteRoute
  '/login': typeof App_notAuthLoginRouteRoute
  '/register': typeof App_notAuthRegisterRouteRoute
  '/admin/': typeof App_authAdminIndexRoute
  '/agent/': typeof App_authAgentIndexRoute
  '/dashboard/': typeof App_authDashboardIndexRoute
  '/merchant/': typeof App_authMerchantIndexRoute
  '/proposal/$uuid/': typeof AppProposalUuidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof App_authIndexRoute
  '/contacts': typeof AppContactsRouteRoute
  '/privacy': typeof AppPrivacyRouteRoute
  '/terms': typeof AppTermsRouteRoute
  '/login': typeof App_notAuthLoginRouteRoute
  '/register': typeof App_notAuthRegisterRouteRoute
  '/admin': typeof App_authAdminIndexRoute
  '/agent': typeof App_authAgentIndexRoute
  '/dashboard': typeof App_authDashboardIndexRoute
  '/merchant': typeof App_authMerchantIndexRoute
  '/proposal/$uuid': typeof AppProposalUuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/__auth': typeof App_authRouteRouteWithChildren
  '/_app/__not-auth': typeof App_notAuthRouteRouteWithChildren
  '/_app/contacts': typeof AppContactsRouteRoute
  '/_app/privacy': typeof AppPrivacyRouteRoute
  '/_app/terms': typeof AppTermsRouteRoute
  '/_app/__not-auth/login': typeof App_notAuthLoginRouteRoute
  '/_app/__not-auth/register': typeof App_notAuthRegisterRouteRoute
  '/_app/__auth/': typeof App_authIndexRoute
  '/_app/__auth/admin/': typeof App_authAdminIndexRoute
  '/_app/__auth/agent/': typeof App_authAgentIndexRoute
  '/_app/__auth/dashboard/': typeof App_authDashboardIndexRoute
  '/_app/__auth/merchant/': typeof App_authMerchantIndexRoute
  '/_app/proposal/$uuid/': typeof AppProposalUuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contacts'
    | '/privacy'
    | '/terms'
    | '/login'
    | '/register'
    | '/admin/'
    | '/agent/'
    | '/dashboard/'
    | '/merchant/'
    | '/proposal/$uuid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contacts'
    | '/privacy'
    | '/terms'
    | '/login'
    | '/register'
    | '/admin'
    | '/agent'
    | '/dashboard'
    | '/merchant'
    | '/proposal/$uuid'
  id:
    | '__root__'
    | '/_app'
    | '/_app/__auth'
    | '/_app/__not-auth'
    | '/_app/contacts'
    | '/_app/privacy'
    | '/_app/terms'
    | '/_app/__not-auth/login'
    | '/_app/__not-auth/register'
    | '/_app/__auth/'
    | '/_app/__auth/admin/'
    | '/_app/__auth/agent/'
    | '/_app/__auth/dashboard/'
    | '/_app/__auth/merchant/'
    | '/_app/proposal/$uuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/__auth': {
      id: '/_app/__auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof App_authRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/__not-auth': {
      id: '/_app/__not-auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof App_notAuthRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/privacy': {
      id: '/_app/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof AppPrivacyRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/terms': {
      id: '/_app/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof AppTermsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/__auth/': {
      id: '/_app/__auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof App_authIndexRouteImport
      parentRoute: typeof App_authRouteRoute
    }
    '/_app/__not-auth/login': {
      id: '/_app/__not-auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof App_notAuthLoginRouteRouteImport
      parentRoute: typeof App_notAuthRouteRoute
    }
    '/_app/__not-auth/register': {
      id: '/_app/__not-auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof App_notAuthRegisterRouteRouteImport
      parentRoute: typeof App_notAuthRouteRoute
    }
    '/_app/__auth/admin/': {
      id: '/_app/__auth/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof App_authAdminIndexRouteImport
      parentRoute: typeof App_authRouteRoute
    }
    '/_app/__auth/agent/': {
      id: '/_app/__auth/agent/'
      path: '/agent'
      fullPath: '/agent/'
      preLoaderRoute: typeof App_authAgentIndexRouteImport
      parentRoute: typeof App_authRouteRoute
    }
    '/_app/__auth/dashboard/': {
      id: '/_app/__auth/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof App_authDashboardIndexRouteImport
      parentRoute: typeof App_authRouteRoute
    }
    '/_app/__auth/merchant/': {
      id: '/_app/__auth/merchant/'
      path: '/merchant'
      fullPath: '/merchant/'
      preLoaderRoute: typeof App_authMerchantIndexRouteImport
      parentRoute: typeof App_authRouteRoute
    }
    '/_app/proposal/$uuid/': {
      id: '/_app/proposal/$uuid/'
      path: '/proposal/$uuid'
      fullPath: '/proposal/$uuid/'
      preLoaderRoute: typeof AppProposalUuidIndexRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface App_authRouteRouteChildren {
  App_authIndexRoute: typeof App_authIndexRoute
  App_authAdminIndexRoute: typeof App_authAdminIndexRoute
  App_authAgentIndexRoute: typeof App_authAgentIndexRoute
  App_authDashboardIndexRoute: typeof App_authDashboardIndexRoute
  App_authMerchantIndexRoute: typeof App_authMerchantIndexRoute
}

const App_authRouteRouteChildren: App_authRouteRouteChildren = {
  App_authIndexRoute: App_authIndexRoute,
  App_authAdminIndexRoute: App_authAdminIndexRoute,
  App_authAgentIndexRoute: App_authAgentIndexRoute,
  App_authDashboardIndexRoute: App_authDashboardIndexRoute,
  App_authMerchantIndexRoute: App_authMerchantIndexRoute,
}

const App_authRouteRouteWithChildren = App_authRouteRoute._addFileChildren(
  App_authRouteRouteChildren,
)

interface App_notAuthRouteRouteChildren {
  App_notAuthLoginRouteRoute: typeof App_notAuthLoginRouteRoute
  App_notAuthRegisterRouteRoute: typeof App_notAuthRegisterRouteRoute
}

const App_notAuthRouteRouteChildren: App_notAuthRouteRouteChildren = {
  App_notAuthLoginRouteRoute: App_notAuthLoginRouteRoute,
  App_notAuthRegisterRouteRoute: App_notAuthRegisterRouteRoute,
}

const App_notAuthRouteRouteWithChildren =
  App_notAuthRouteRoute._addFileChildren(App_notAuthRouteRouteChildren)

interface AppRouteChildren {
  App_authRouteRoute: typeof App_authRouteRouteWithChildren
  App_notAuthRouteRoute: typeof App_notAuthRouteRouteWithChildren
  AppContactsRouteRoute: typeof AppContactsRouteRoute
  AppPrivacyRouteRoute: typeof AppPrivacyRouteRoute
  AppTermsRouteRoute: typeof AppTermsRouteRoute
  AppProposalUuidIndexRoute: typeof AppProposalUuidIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  App_authRouteRoute: App_authRouteRouteWithChildren,
  App_notAuthRouteRoute: App_notAuthRouteRouteWithChildren,
  AppContactsRouteRoute: AppContactsRouteRoute,
  AppPrivacyRouteRoute: AppPrivacyRouteRoute,
  AppTermsRouteRoute: AppTermsRouteRoute,
  AppProposalUuidIndexRoute: AppProposalUuidIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
